"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewItem = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const common_1 = require("@/components/common");
require("@/components/common");
/**
 * mm-review-item
 * 상품 상세(커머스) 도메인의 사용자 리뷰 카드.
 * 별점·본문·작성자·작성일을 prop으로 받아 표시한다.
 */
let ReviewItem = class ReviewItem extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.rating = 5;
        this.content = '';
        this.author = '';
        this.datetime = '';
    }
    render() {
        return (0, lit_1.html) `
      <mm-surface variant="outlined">
        <div class="body">
          <div class="rating" role="img" aria-label="${this.rating}점">
            ${Array.from({ length: this.rating }, () => (0, lit_1.html) `
                <mm-icon name=${common_1.ICON_NAMES.FAVORITE_SELECTED}></mm-icon>
              `)}
          </div>

          <mm-paragraph>${this.content}</mm-paragraph>
          ${this.renderMeta()}
        </div>
      </mm-surface>
    `;
    }
    renderMeta() {
        if (!this.author && !this.datetime)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-list-item size="medium" label=${this.author} description=${this.datetime}></mm-list-item>
    `;
    }
};
ReviewItem.styles = (0, lit_1.css) `
    :host {
      display: block;
      width: 100%;
    }

    .body {
      display: flex;
      flex-direction: column;
      gap: var(--space-3);
    }

    .rating {
      display: flex;
    }

    .rating {
      color: var(--accent-color);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: Number })
], ReviewItem.prototype, "rating", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ReviewItem.prototype, "content", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ReviewItem.prototype, "author", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], ReviewItem.prototype, "datetime", void 0);
ReviewItem = __decorate([
    (0, decorators_js_1.customElement)('mm-review-item')
], ReviewItem);
exports.ReviewItem = ReviewItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmV2aWV3LWl0ZW0uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJyZXZpZXctaXRlbS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBb0Q7QUFDcEQscURBQTJEO0FBRTNELGdEQUFnRDtBQUNoRCwrQkFBNEI7QUFFNUI7Ozs7R0FJRztBQUVJLElBQU0sVUFBVSxHQUFoQixNQUFNLFVBQVcsU0FBUSxnQkFBVTtJQUFuQzs7UUFxQnVCLFdBQU0sR0FBRyxDQUFDLENBQUE7UUFDVixZQUFPLEdBQUcsRUFBRSxDQUFBO1FBQ1osV0FBTSxHQUFHLEVBQUUsQ0FBQTtRQUNYLGFBQVEsR0FBRyxFQUFFLENBQUE7SUE2QjNDLENBQUM7SUEzQkMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7Ozt1REFHd0MsSUFBSSxDQUFDLE1BQU07Y0FDcEQsS0FBSyxDQUFDLElBQUksQ0FDVixFQUFFLE1BQU0sRUFBRSxJQUFJLENBQUMsTUFBTSxFQUFFLEVBQ3ZCLEdBQUcsRUFBRSxDQUFDLElBQUEsVUFBSSxFQUFBO2dDQUNRLG1CQUFVLENBQUMsaUJBQWlCO2VBQzdDLENBQ0Y7OzswQkFHYSxJQUFJLENBQUMsT0FBTztZQUMxQixJQUFJLENBQUMsVUFBVSxFQUFFOzs7S0FHeEIsQ0FBQTtJQUNILENBQUM7SUFFTyxVQUFVO1FBQ2hCLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxJQUFJLENBQUMsSUFBSSxDQUFDLFFBQVE7WUFBRSxPQUFPLGFBQU8sQ0FBQTtRQUVsRCxPQUFPLElBQUEsVUFBSSxFQUFBOzBDQUMyQixJQUFJLENBQUMsTUFBTSxnQkFBZ0IsSUFBSSxDQUFDLFFBQVE7S0FDN0UsQ0FBQTtJQUNILENBQUM7O0FBbkRNLGlCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7R0FtQmxCLENBQUE7QUFDMkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzBDQUFXO0FBQ1Y7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzJDQUFhO0FBQ1o7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzBDQUFZO0FBQ1g7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzRDQUFjO0FBeEI5QixVQUFVO0lBRHRCLElBQUEsNkJBQWEsRUFBQyxnQkFBZ0IsQ0FBQztHQUNuQixVQUFVLENBcUR0QjtBQXJEWSxnQ0FBVSJ9